/* GiftInOne Editor: one fail-closed stock decision for Review and Add to Cart.
 * The original Shopify controller remains the owner of native button state.
 */
(function () {
  'use strict';
  function normalize(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
  function readJSON(element) {
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (_error) { return null; }
  }
  function evaluate(input) {
    var choices = input.selectedOptions || [];
    var variants = Array.isArray(input.variants) ? input.variants : [];
    var variant = null;
    if (choices.length) {
      variant = variants.find(function (item) {
        return choices.every(function (choice) { return normalize(choice) !== ''; }) &&
          Array.isArray(item.options) && item.options.length === choices.length &&
          item.options.every(function (option, index) { return normalize(option) === normalize(choices[index]); });
      });
    } else if (variants.length === 1) variant = variants[0];
    // Multiple-variant products must have a complete, current selection. Never
    // fall back to an old hidden ID while the customer sees another combination.
    var variantId = variant ? String(variant.id) : '';
    var current = input.liveVariant;
    var currentMatches = !!(current && String(current.id) === variantId);
    var soldOut = !!(variant && (variant.soldOut === true || variant.available !== true ||
      currentMatches && current.available === false));
    var unavailable = !variant;
    var nativeIdMatches = !!(variantId && String(input.nativeVariantId || '') === variantId);
    var nativeLabel = normalize(input.nativeText).toLowerCase();
    var soldOutLabel = normalize(input.soldOutLabel || 'Sold out').toLowerCase();
    var unavailableLabel = normalize(input.unavailableLabel || 'Unavailable').toLowerCase();
    if (input.nativeDisabled && nativeIdMatches) {
      if (nativeLabel === soldOutLabel || /^sold\s*out$/.test(nativeLabel)) soldOut = true;
      if (nativeLabel === unavailableLabel) unavailable = true;
    }
    // After a long idle the local variant list may be stale. An explicit
    // Shopify null selection clears the native ID and marks it unavailable;
    // that completed response must not look like an unfinished ID update.
    if (!input.pending && input.hasNativeForm && input.liveVariantIsNull &&
        input.nativeDisabled && !normalize(input.nativeVariantId) && nativeLabel === unavailableLabel) unavailable = true;
    var requestError = normalize(input.requestError);
    // A failed section update is unresolved, but no longer loading. Keep the
    // purchase gate closed and offer recovery instead of waiting forever.
    var pending = !requestError && (!!input.pending || !unavailable &&
      (!!(variant && input.hasNativeForm && !nativeIdMatches) || !!(variant && input.nativeDisabled && !soldOut)));
    var message = requestError || (unavailable ? 'This combination is unavailable. Please choose another option.' :
      soldOut ? 'This option is sold out. Please choose another option.' :
      pending ? 'Updating your options. Please wait…' : '');
    return { available: !unavailable && !soldOut && !pending && !requestError, pending: pending,
      error: !!requestError, retryable: !!requestError && !!input.canRetry,
      soldOut: soldOut, unavailable: unavailable, variantId: variantId, message: message };
  }
  function getScope(config) {
    var sectionId = String(config.sectionId || '');
    var scope = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
    if (!scope) scope = Array.prototype.find.call(document.querySelectorAll('product-info'), function (candidate) {
      return sectionId ? candidate.getAttribute('data-section') === sectionId :
        String(candidate.getAttribute('data-product-id') || '') === String(config.productId || '');
    });
    return scope || null;
  }
  function read(config, main, next) {
    var scope = getScope(config);
    var picker = main && main.querySelector('#variant-picker-container');
    var groups = picker ? picker.querySelectorAll('fieldset, .product-form__input--dropdown') : [];
    // A default-only product has no picker. For other products, the original
    // picker is used only until its modal counterpart has been initialized.
    if (!groups.length && scope) groups = scope.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown');
    var choices = Array.prototype.map.call(groups, function (group) {
      var selected = group.querySelector('input[type="radio"]:checked, select');
      return selected ? selected.value : '';
    });
    var nativeForm = scope && scope.querySelector('product-form');
    var nativeId = nativeForm && nativeForm.querySelector('input[name="id"]');
    var submit = nativeForm && nativeForm.querySelector('[type="submit"][name="add"], [type="submit"]');
    var liveNode = scope && scope.querySelector('variant-selects [data-selected-variant]');
    var live = readJSON(liveNode);
    var nativeDisabled = nativeForm && typeof nativeForm.variantDisabled === 'boolean' ? nativeForm.variantDisabled :
      !!(submit ? submit.disabled || submit.getAttribute('aria-disabled') === 'true' :
        next && (next.disabled || next.getAttribute('aria-disabled') === 'true'));
    var strings = window.variantStrings || {};
    return evaluate({
      variants: config.variants,
      selectedOptions: choices,
      liveVariant: live,
      liveVariantIsNull: !!(liveNode && liveNode.textContent.trim() === 'null'),
      pending: !!(scope && scope.pendingRequestUrl),
      requestError: scope && scope.gioVariantRequestError,
      canRetry: !!(scope && typeof scope.retryVariantRequest === 'function' && scope.dataset.gioEditorRouteChanging !== 'true'),
      hasNativeForm: !!nativeForm,
      nativeVariantId: nativeId && nativeId.value,
      nativeDisabled: nativeDisabled,
      nativeText: nativeForm && typeof nativeForm.variantText === 'string' ? nativeForm.variantText : submit && submit.textContent,
      soldOutLabel: strings.soldOut,
      unavailableLabel: strings.unavailable
    });
  }
  window.GIOEditorV2Availability = { read: read, evaluate: evaluate, getScope: getScope };
}());
